export const SELECTED_TAB_PARAM = 'tab'
export const WORKSPACES_TAB_VALUES = {
  WORKSPACES: 'workspaces',
  BRAND_NOTES: 'brand-notes',
  ARCHIVED: 'archived',
}
